<template>
  <tr
    :id="`auction_${auction.id}`"
    class="artwork-row"
  >
    <td :class="{ 'border-bottom-0': !closedOrdersDetails }">
      {{ auction.index }}
    </td>
    <td :class="{ 'border-bottom-0': !closedOrdersDetails }">
      {{ auction.artwork.catalogNumber }}
    </td>
    <td :class="{ 'border-bottom-0': !closedOrdersDetails }">
      <img :src="auction.artwork.imageThumbUrl" alt="">
    </td>
    <td :class="{ 'border-bottom-0': !closedOrdersDetails }">
      {{ auction.artwork.artist.fullname }}
    </td>
    <td :class="{ 'border-bottom-0': !closedOrdersDetails }">
      {{ auction.artwork.name }}
    </td>
    <td :class="{ 'border-bottom-0': !closedOrdersDetails }">
      {{ I18n.t("artworks.price", { price: formatPrice(auction.artwork.startingPrice) }) }}
    </td>
    <td :class="{ 'border-bottom-0': !closedOrdersDetails }">
      <span v-if="auction.artwork.estimationMin">
        {{ I18n.t("artworks.estimated_prices_with_currency",
          { price_min: formatPrice(auction.artwork.estimationMin),
            price_max: formatPrice(auction.artwork.estimationMax) }) }}
      </span>
    </td>
    <td :class="{ 'border-bottom-0': !closedOrdersDetails }">
      <div v-if="auction.leadingUser">
        <span
          class="d-block"
          v-html="auction.value"
        />
        <span v-html="auction.leadingUser.fullname" />
      </div>
    </td>
    <td
      @click="toggleDetails"
      class="collapse-row"
      :class="{ 'border-bottom-0': !closedOrdersDetails }"
    >
     <span
      :class="{
        'icon-arrow-bottom': closedOrdersDetails,
        'icon-arrow-top': !closedOrdersDetails,
      }"
    />
    </td>
  </tr>
</template>

<script>
  import { mapState, mapActions, mapMutations } from 'vuex';
  import { formatNumber } from '@/shared/helpers';

  export default {
    name: 'OrdersRow',
    props: {
      auction: {
        type: Object,
        required: true,
      },
    },
    data() {
      return {
        formatPrice: formatNumber,
      };
    },
    methods: {
      ...mapMutations([
        'SET_NET_TABLE',
        'REMOVE_BIDS_DETAILS',
        'SET_DETAILS_ROW',
      ]),
      ...mapActions([
        'fetchAuctionsLastOrder',
        'fetchAuctionsBids',
      ]),
      toggleDetails() {
        if (this.closedOrdersDetails) {
          this.REMOVE_BIDS_DETAILS();
          this.SET_DETAILS_ROW(this.auction.id);
          this.fetchAuctionsLastOrder({ id: this.auction.id });
          this.fetchAuctionsBids({ id: this.auction.id });
        } else {
          this.REMOVE_BIDS_DETAILS();
        }
      },
    },
    computed: {
      ...mapState(['activeDetails']),
      closedOrdersDetails() {
        return this.activeDetails !== this.auction.id;
      },
    },
  };
</script>



// WEBPACK FOOTER //
// app/javascript/packs/employees_orders_panel/components/orders/orders_row.vue?0ccde5d9